import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BiqButtonComponent } from '../biq-button/biq-button.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UserBiqData } from '@app/schemas/biq';
import { Store } from '@ngrx/store';
import { updateUserBiq } from '@app/state/actions/biq.action';
import { BIQ_GENDER, BIQ_TOTAL_QUESTIONS } from '@app/utils/constants';
import { selfDescibeTextValidator } from '@app/validations/textValidations';

@Component({
  selector: 'app-biq-gender',
  imports: [
    ProgressBarComponent,
    BiqButtonComponent,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
  ],
  templateUrl: './gender.component.html',
  styleUrl: './gender.component.css'
})
export class GenderComponent implements OnInit {
  @Output() continueEmitter = new EventEmitter<void>();
  public questNo: number = 3;
  public totalQuestions: number = BIQ_TOTAL_QUESTIONS;
  public selfDescribeText = new FormControl({ value: '', disabled: true });
  public genderControl = new FormControl('', [Validators.required]);
  public genderOptions = BIQ_GENDER;
  public storedBiqData!: UserBiqData;
  public disableOptions = ['Prefer not to answer', 'self-describe'];

  constructor(private store: Store<{ userBiq: UserBiqData }>) {
    this.store.select('userBiq').subscribe(value => {
      this.storedBiqData = value;
      if (value && value.gender) {
        const predefinedOptions = this.genderOptions.map(opt => opt.value);
        if (predefinedOptions.includes(value.gender)) {
          this.genderControl.setValue(value.gender);
        } else {
          // It's a self-described gender
          this.genderControl.setValue('self-describe');
          this.selfDescribeText.setValue(value.gender);
        }
      }
    });
  }

  ngOnInit() {
    this.genderControl.valueChanges.subscribe(value => {
      if (value !== 'self-describe') {
        this.selfDescribeText.setValue('');
      }

      if (value === 'self-describe') {
        this.selfDescribeText.setValidators([selfDescibeTextValidator()]);
        this.selfDescribeText.enable();
      } else {
        this.selfDescribeText.clearValidators();
        this.selfDescribeText.setValue('');
        this.selfDescribeText.disable();
      }

      this.selfDescribeText.updateValueAndValidity();
    });
  }

  selectSelfDescribe() {
    this.genderControl.setValue('self-describe');
  }

  onClickContinue() {
    this.genderControl.markAsTouched();
    if (this.genderControl.invalid || this.selfDescribeText.invalid) return;
    
    const gender = this.genderControl.value == "self-describe"
                    ? this.selfDescribeText.value! 
                    : this.genderControl.value!;
    const updatedBiq = {
      ...this.storedBiqData,
      gender: gender,
    }
    this.store.dispatch(updateUserBiq({ user: updatedBiq }));
    this.continueEmitter.emit();
  }
}
